import React from "react";
import { useTranslation } from "react-i18next";
import { mergeStyles } from "office-ui-fabric-react";
import NewFormField from "../../../../common/layout/form/NewFormField";

export interface QuantitiesProps {}

const container = mergeStyles({
  display: "flex",
  justifyContent: "space-between",
  marginTop: 15
});

const field = mergeStyles({
  width: 250,
});

const Quantities: React.FC<QuantitiesProps> = () => {
  const { t } = useTranslation("admin");
  return (
    <div className={container}>
      <div className={field}>
        <NewFormField name="quantity" label={t("nav.quantityPieces")} />
      </div>
      <div className={field}>
        <NewFormField name="quantityTaken" label={t("nav.receivedQuantity")} />
      </div>
    </div>
  );
};

export default Quantities;
